module.exports = __webpack_public_path__ + "static/img/13.1e55b14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/13.png
// module id = 8ZA6
// module chunks = 0